/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Suspended_AuditInputs */

const en_storefront_suspended_audit = /** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront Suspended`)
};

const es_storefront_suspended_audit = /** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda Suspendida`)
};

const fr_storefront_suspended_audit = /** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine suspendue`)
};

const de_storefront_suspended_audit = /** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront ausgesetzt`)
};

const id_storefront_suspended_audit = /** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase Ditangguhkan`)
};

/** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */
const ja_storefront_suspended_audit = en_storefront_suspended_audit;

/** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */
const zh_storefront_suspended_audit = en_storefront_suspended_audit;

/** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */
const ar_storefront_suspended_audit = en_storefront_suspended_audit;

/** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */
const it_storefront_suspended_audit = en_storefront_suspended_audit;

/** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */
const ru_storefront_suspended_audit = en_storefront_suspended_audit;

/** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */
const pt_storefront_suspended_audit = en_storefront_suspended_audit;

/** @type {(inputs: Storefront_Suspended_AuditInputs) => LocalizedString} */
const ko_storefront_suspended_audit = en_storefront_suspended_audit;

/**
* | output |
* | --- |
* | "Storefront Suspended" |
*
* @param {Storefront_Suspended_AuditInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_suspended_audit = /** @type {((inputs?: Storefront_Suspended_AuditInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Suspended_AuditInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_suspended_audit(inputs)
	if (locale === "es") return es_storefront_suspended_audit(inputs)
	if (locale === "fr") return fr_storefront_suspended_audit(inputs)
	if (locale === "de") return de_storefront_suspended_audit(inputs)
	if (locale === "ja") return ja_storefront_suspended_audit(inputs)
	if (locale === "zh") return zh_storefront_suspended_audit(inputs)
	if (locale === "ar") return ar_storefront_suspended_audit(inputs)
	if (locale === "id") return id_storefront_suspended_audit(inputs)
	if (locale === "it") return it_storefront_suspended_audit(inputs)
	if (locale === "ru") return ru_storefront_suspended_audit(inputs)
	if (locale === "pt") return pt_storefront_suspended_audit(inputs)
	return ko_storefront_suspended_audit(inputs)
});